import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import store from './../store'
import { removeTrailingSlash } from './../utils/js/shared_helpers'

class RouteListener extends Component {
    constructor(props) {
        super(props)
        this.prevPath = removeTrailingSlash(window.location.pathname)

        // FOR EVERY ROUTE CHANGE
        props.history.listen(location => {
            if (location.pathname === this.prevPath) return
            this.prevPath = removeTrailingSlash(location.pathname)

            // if this is a live tracker route (games)
            this.onLivetrackerRouteChange(location)
            store.dispatch({ type: 'WS_DISCONNECT' }) // disconnect ws connection
            store.dispatch({ type: 'RESET_INIT_VIDEO_FEED_REQUEST' }) // reset initial video request param
            store.dispatch({ type: 'REFRESH_ADUTIL_TARGET' }) // reset ad util target object on gamechange
            store.dispatch({ type: 'ADS_REFRESH_EVENT' }) // refresh all the ads on the page
        })

        // Stop continuous push of same url into history
        const prevHistoryPush = props.history.push
        props.history.push = (pathname, state = {}) => {
            if (removeTrailingSlash(pathname) !== removeTrailingSlash(this.prevPath)) {
                prevHistoryPush(removeTrailingSlash(pathname), state)
            }
        }
    }

    componentDidMount() {
        /*
         * Live Tracker Route Change
         * - On initial app load, if this is a live tracker route (games), specify a route change is occuring
         */
        this.onLivetrackerRouteChange(window.location)

        /*
         * Get UMP Nonce (for Sign In)
         * - On initial app load, we need to grab the nonce value from WP to keep jan rain logins consistent across environments
         * - value retrieved is added to the global UMP obj created in index.html
         */
        store.dispatch({ type: 'GET_UMP_NONCE' })

        /*
         * Initialize Header Leaderboard ad
         * - On initial app load, we need to fire up the header leaderboard ad
         */
        if (!window.location.pathname.includes('/videos')) {
            store.dispatch({ type: 'INIT_HEADER_LEADERBOARD_AD' })
        }
    }

    onLivetrackerRouteChange(location) {
        if (location.pathname) {
            let paths = location.pathname.split('/')
            let pageType = paths[3]
            let gameCode = paths[4]

            if (pageType && gameCode && pageType === 'games') {
                store.dispatch({
                    type: 'ROUTE_CHANGE',
                    location: location,
                    id: gameCode,
                })
            }
        }
    }

    render() {
        return <React.Fragment>{this.props.children}</React.Fragment>
    }
}

export default withRouter(RouteListener)
